"use strict";

/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 16/12/2023
 */

exports.LogicalSymbols = Object.freeze({
  AND_START: "(",
  AND_END: ")",
  OR_START: "[",
  OR_END: "]",
  TYPE_OR: "OR",
  TYPE_AND: "AND"
});